import React from "react";
import { Link } from "react-router-dom";
import { CurrencyState } from "../Context";

function TableRow({ name, icon, price_change_percentage, current_price, id }) {
  const { symbol } = CurrencyState();

  return (
    <tr>
      <td>
        <Link to={`/AssetPage/${id}`}>
          <img src={icon} alt="" />
        </Link>
      </td>
      <td className="name-col">
        <Link to={`/AssetPage/${id}`}>{name}</Link>
      </td>
      <td>
        {symbol}
        {current_price.toLocaleString()}
      </td>
      <td>
        {price_change_percentage < 0 ? (
          <span className="red">{price_change_percentage.toFixed(2)}%</span>
        ) : (
          <span className="green">{price_change_percentage.toFixed(2)}%</span>
        )}
      </td>
      <td>
        <Link to={`/Buy/${id}`}>
          <button>Buy</button>
        </Link>{" "}
        <Link to={`/Sell/${id}`}>
          <button className="sell-btn">Sell</button>
        </Link>
      </td>
    </tr>
  );
}

export default TableRow;
